import { componentBaseStyles } from '@adaptive-web/adaptive-ui';
import { cornerRadiusLayer, densityLayer, fillColor } from '@adaptive-web/adaptive-ui/reference';
import { css } from '@microsoft/fast-element';

export default css`
	${componentBaseStyles}

	:host {
		display: flex;
		flex-direction: column;
		width: fit-content;
		max-width: 470px;
		border-radius: ${cornerRadiusLayer};
		padding: var(--padding-md);
		gap: calc(var(--padding-sm) + 4px);
		color: var(--text-color);
		z-index: 1;
		position: relative;
	}

	:host::after {
		content: '';
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: ${fillColor};
		border-radius: ${cornerRadiusLayer};
		filter: opacity(0.8);
		z-index: -1;
	}

	p {
		margin: 0;
		padding: 0;
	}

	::slotted([slot='action']) {
		width: fit-content;
	}
	@media (max-width: 490px) {
		:host {
			width: 100%;
		}
	}
`;